import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SubAppLoaderService {

  loadFromConfig(subApps: any): void {
    const list = subApps?.microFrontends as any[] | undefined;
    if (!Array.isArray(list)) return;

    for (const mf of list) {
      if (!mf?.active || mf?.type !== 'module') continue;

      // 1) Styles
      const styles: string[] =
        (mf.entry?.styles ?? (mf.entry?.style ? [mf.entry.style] : [])) as string[];
      for (const href of styles) {
        if (!href) continue;
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }

      // 2) Module-Skripte
      const scripts: string[] =
        (mf.entry?.scripts ?? (mf.entry?.src ? [mf.entry.src] : [])) as string[];
      for (const src of scripts) {
        if (!src) continue;
        const s = document.createElement('script');
        s.type = 'module';
        s.src = src;
        document.body.appendChild(s);
      }
    }
  }
}
